import { render, staticRenderFns } from "./RelaxVideos.vue?vue&type=template&id=1a0121fb&scoped=true&"
import script from "./RelaxVideos.vue?vue&type=script&lang=js&"
export * from "./RelaxVideos.vue?vue&type=script&lang=js&"
import style0 from "./RelaxVideos.vue?vue&type=style&index=0&id=1a0121fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0121fb",
  null
  
)

export default component.exports